import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/hooks/useAuthStore';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Staff from '@/pages/Staff';
import Users from '@/pages/Users';
import Households from '@/pages/Households';
import Settings from '@/pages/Settings';
import SettingsMfa from '@/pages/SettingsMfa';
import SettingsIntegrations from '@/pages/SettingsIntegrations';
import ProductMetrics from '@/pages/ProductMetrics';
import Audit from '@/pages/Audit';
import ImportJobs from '@/pages/ImportJobs';
import AIOps from '@/pages/AIOps';
import Breakglass from '@/pages/Breakglass';
import FeatureFlags from '@/pages/FeatureFlags';
import Layout from '@/components/Layout';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Layout>{children}</Layout>;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff"
        element={
          <ProtectedRoute>
            <Staff />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path="/households"
        element={
          <ProtectedRoute>
            <Households />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/mfa"
        element={
          <ProtectedRoute>
            <SettingsMfa />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/integrations"
        element={
          <ProtectedRoute>
            <SettingsIntegrations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/metrics"
        element={
          <ProtectedRoute>
            <ProductMetrics />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit"
        element={
          <ProtectedRoute>
            <Audit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/import-jobs"
        element={
          <ProtectedRoute>
            <ImportJobs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ai-ops"
        element={
          <ProtectedRoute>
            <AIOps />
          </ProtectedRoute>
        }
      />
      <Route
        path="/breakglass"
        element={
          <ProtectedRoute>
            <Breakglass />
          </ProtectedRoute>
        }
      />
      <Route
        path="/feature-flags"
        element={
          <ProtectedRoute>
            <FeatureFlags />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
